import React from 'react';
import { useTranslation } from 'react-i18next';
import { Slider, Col, Row } from '@kaleyra/emmy';

import Styles from './index.module.scss';

export type DispatchPropsType = {
	onClose: () => void;
};

const ViewContact: React.FC<DispatchPropsType> = ({ onClose }) => {
	const { t } = useTranslation();

	return (
		<Slider
			visibility={true}
			containerId={'root-modal'}
			onClose={onClose}
			title={t('BLD00373')}
		>
			<Row className={Styles.container}>
				<Col size={12}>
					<p className={Styles.title}>{t('basicInformation')}</p>
					<Row>
						<Col size={6}>
							<p className={Styles.colTitle}>{t('BLD00374')}</p>
						</Col>
						<Col size={6}>
							<p className={Styles.colData}>Jhon Doe</p>
						</Col>
					</Row>
					<Row>
						<Col size={6}>
							<p className={Styles.colTitle}>
								{t('mainMobileNumber')}
							</p>
						</Col>
						<Col size={6}>
							<p className={Styles.colData}>+01 1234567890</p>
						</Col>
					</Row>
					<Row>
						<Col size={6}>
							<p className={Styles.colTitle}>{t('BLD00004')}</p>
						</Col>
						<Col size={6}>
							<p className={Styles.colData}>abc@gmail.com</p>
						</Col>
					</Row>
					<Row>
						<Col size={6}>
							<p className={Styles.colTitle}>{t('BLD00375')}</p>
						</Col>
						<Col size={6}>
							<p className={Styles.colData}>Bangalore</p>
						</Col>
					</Row>
					<Row>
						<Col size={6}>
							<p className={Styles.colTitle}>{t('BLD00376')}</p>
						</Col>
						<Col size={6}>
							<p className={Styles.colData}>-</p>
						</Col>
					</Row>
				</Col>
				<Col size={12} className={Styles.lookupContainer}>
					<p className={Styles.title}>{t('BLD00505')}</p>
					<Col size={12} className={Styles.subsection}>
						<p>{t('BLD00381')}</p>
						<Row>
							<Col size={6}>
								<p className={Styles.colTitle}>
									{t('BLD00377')}
								</p>
							</Col>
							<Col size={6}>
								<p className={Styles.colData}>India</p>
							</Col>
						</Row>
						<Row>
							<Col size={6}>
								<p className={Styles.colTitle}>
									{t('BLD00159')}
								</p>
							</Col>
							<Col size={6}>
								<p className={Styles.colData}>
									Airtel // Andhra Pradesh
								</p>
							</Col>
						</Row>
					</Col>
					<Col size={12} className={Styles.subsection}>
						<p>{t('BLD00382')}</p>{' '}
						<Row>
							<Col size={6}>
								<p className={Styles.colTitle}>
									{t('BLD00377')}
								</p>
							</Col>
							<Col size={6}>
								<p className={Styles.colData}>India</p>
							</Col>
						</Row>
						<Row>
							<Col size={6}>
								<p className={Styles.colTitle}>
									{t('BLD00159')}
								</p>
							</Col>
							<Col size={6}>
								<p className={Styles.colData}>
									Airtel // Andhra Pradesh
								</p>
							</Col>
						</Row>
					</Col>
					<Col size={12} className={Styles.subsection}>
						<p>{t('BLD00383')}</p>{' '}
						<Row>
							<Col size={6}>
								<p className={Styles.colTitle}>
									{t('BLD00377')}
								</p>
							</Col>
							<Col size={6}>
								<p className={Styles.colData}>India</p>
							</Col>
						</Row>
						<Row>
							<Col size={6}>
								<p className={Styles.colTitle}>
									{t('BLD00159')}
								</p>
							</Col>
							<Col size={6}>
								<p className={Styles.colData}>
									Airtel // Andhra Pradesh
								</p>
							</Col>
						</Row>
					</Col>
				</Col>
			</Row>
		</Slider>
	);
};

export default ViewContact;
